import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BotTextPipe } from './bot-text.pipe';
import { DataKeyNamePipe } from './data-key-name.pipe';
import { FullBotTextPipe } from './full-bot-text.pipe';
import { HtmlStringifyPipe } from './html-stringify.pipe';
import { TranslatePipe } from './protocol-droid.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { TrustRessourcePipe } from './trust-ressource.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [BotTextPipe, FullBotTextPipe, TrustRessourcePipe, HtmlStringifyPipe, DataKeyNamePipe, SafeHtmlPipe, TranslatePipe],
  exports: [BotTextPipe, FullBotTextPipe, TrustRessourcePipe, HtmlStringifyPipe, DataKeyNamePipe, SafeHtmlPipe, TranslatePipe]
})
export class PipesModule {}
